import React, { FunctionComponent, useEffect } from "react";

import * as H from "history";
import { useDispatch } from "react-redux";
import { Router, Switch, Route } from "react-router-dom";

import { clearBreadcrumbs } from "../../features/breadcrumbs/breadcrumbsSlice";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { Evaluations } from './index';
import { NewEvaluation } from './new';
import { EditEvaluation } from './edit';

interface AdminRouterProps {
  history: H.History<any>;
}

const prefix = Prefixes.evaluation;

export const EvaluationsRouter: FunctionComponent<AdminRouterProps> = ({
  history,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return history.listen((location) => {
      dispatch(clearBreadcrumbs());
    });
  }, [dispatch, history]);
  return <Router history={history}>
    <Switch>
      <Route path={`${prefix}${ActionSuffixes.new}`} exact>
        <NewEvaluation />
      </Route>
      <Route path={`${prefix}/:id${ActionSuffixes.edit}`} exact>
        <EditEvaluation />
      </Route>
      <Route path={prefix}>
        <Evaluations />
      </Route>
    </Switch>
  </Router>;
};